namespace GeniuzPOS.PosShift {
    export interface PaymentTypeForm {
        PaymentType: Serenity.IntegerEditor;
        PaymentName: Serenity.StringEditor;
    }

    export class PaymentTypeForm extends Serenity.PrefixedContext {
        static formKey = 'PosShift.PaymentType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PaymentTypeForm.init)  {
                PaymentTypeForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;

                Q.initFormType(PaymentTypeForm, [
                    'PaymentType', w0,
                    'PaymentName', w1
                ]);
            }
        }
    }
}
